import { CSSProperties, useState } from "react";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { defaultProfileImage } from "../../../utils/constants";
import { sanitizeHtml } from "../../../helpers/sanitizeHtml";

type Props = {
    type: 'Open Forum' | 'Mastermind Circle';
    topic: string;
    content: string;
    author: {
        avatar: string;
        username: string;
        isMine: boolean;
    };
    facilitator?: {
        avatar: string;
        username: string;
        isTeam: boolean;
    };
    circles: {
        quantity: number;
        previewAvatars: string[];
    };
    onSuspendForum: () => void;
}

export const CommunityAdminReviewContent = ({ type, topic, content, author, facilitator, circles, onSuspendForum }: Props) => {
    const [show, setShow] = useState(true);
    const [readMoreProps, setReadMoreStyles] = useState<{ complete: boolean, styles: CSSProperties }>({ complete: false, styles: {width: '100%', maxHeight: '15rem', 'overflow': 'auto'} })

    const _toogleRead = () => {
        setReadMoreStyles((prev) => ({ complete: !prev.complete,  styles: { width: '100%', maxHeight: prev.complete ? '15rem': 'fit-content', 'overflow': 'auto' } }))
    }
    return (
        <div className="community-review">
            <div className="community-review__header" onClick={() => setShow(prev => !prev)}>
                <span>
                    { type } INFO
                </span>
                <svg style={{ rotate: show ? '0deg': '180deg' }} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                    <path d="M12.5192 9.70701C12.4756 9.75059 12.4239 9.78517 12.367 9.80876C12.3101 9.83235 12.2491 9.84449 12.1875 9.84449C12.1259 9.84449 12.0649 9.83235 12.008 9.80876C11.9511 9.78517 11.8994 9.75059 11.8559 9.70701L7.50002 5.35056L3.14416 9.70701C3.0562 9.79497 2.93691 9.84438 2.81252 9.84438C2.68813 9.84438 2.56883 9.79497 2.48088 9.70701C2.39292 9.61905 2.34351 9.49976 2.34351 9.37537C2.34351 9.25098 2.39292 9.13168 2.48088 9.04373L7.16838 4.35623C7.21191 4.31265 7.26361 4.27807 7.32051 4.25448C7.37742 4.23089 7.43842 4.21875 7.50002 4.21875C7.56162 4.21875 7.62261 4.23089 7.67952 4.25448C7.73642 4.27807 7.78812 4.31265 7.83166 4.35623L12.5192 9.04373C12.5627 9.08726 12.5973 9.13896 12.6209 9.19587C12.6445 9.25277 12.6566 9.31377 12.6566 9.37537C12.6566 9.43697 12.6445 9.49797 12.6209 9.55487C12.5973 9.61178 12.5627 9.66348 12.5192 9.70701Z" fill="#151515"/>
                </svg>
            </div>
            {show && (
                <>
                    <div className="community-review__content">
                        <h6>{topic}</h6>
                        <div style={readMoreProps.styles}>
                            <span className="content" dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}></span>
                        </div>
                        <button onClick={_toogleRead}>
                            { readMoreProps.complete ? 'READ LESS': 'READ MORE' }
                        </button>
                    </div>

                    <svg xmlns="http://www.w3.org/2000/svg" width="295" height="1" viewBox="0 0 295 1" fill="none">
                        <path d="M0 0.5H295" stroke="#E9E9E9"/>
                    </svg>

                    <div className="community-review__owners">
                        <div className="owner-item">
                            <span className="owner-item__type">Owned by</span>
                            <div className="owner-item__info">
                                <img src={toAbsoluteUrl(author.avatar) || defaultProfileImage} onError={(e) => { e.currentTarget.src = defaultProfileImage }}/>
                                <span className="owner-item__info__name">
                                    {author.username}
                                </span>
                                <span className="owner-item__info__tag">
                                    HOST
                                </span>
                            </div>
                        </div>
                        {facilitator && (
                            <div className="owner-item">
                                <span className="owner-item__type">Facilitator</span>
                                <div className="owner-item__info">
                                    <span className="owner-item__info__name">
                                        {facilitator.username}
                                    </span>
                                    <span className="owner-item__info__tag">
                                        TEAM
                                    </span>
                                </div>
                            </div>
                        )}

                        <div className="owner-circle-item">
                            <span className="owner-circle-item__type">
                                Circle
                            </span>
                            <div className="owner-circle-item__avatars">
                                {circles.previewAvatars.map((a,i) => (
                                    <img src={toAbsoluteUrl(a)} onError={(e) => { e.currentTarget.src = defaultProfileImage }} key={i}/>
                                ))}
                                <span>
                                    +{circles.quantity}
                                </span>
                            </div>
                            
                            
                        </div>
                    </div>

                    <button className="community-review__suspend" onClick={onSuspendForum}>
                        Suspend Forum
                    </button>
                </>
            )}
        </div>
    )    
}